/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button, Form, Input, Modal } from "antd";
import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CreateIpWhteList,
  GetIpWhteList,
} from "redux/action/ipWhiteListAction";

import { CloseSvg } from "utils/svgs";
import "./index.scss";

import { CreateAPIKeyProps } from "./popUpTypes";
import { AppDispatch } from "redux/store";

const CreateAPIKeyModal: FC<CreateAPIKeyProps> = (props) => {
  const { isModalOpen, editFormValue, handleClose } = props;
  const [form] = Form.useForm();

  const [currentIp, setCurrentIp] = useState<string>("");

  const { isLoading } = useSelector((state: any) => state.IpWhiteList);
  const dispatch = useDispatch<AppDispatch>();

  const onSubmit = async (values: any) => {
    if (Object.keys(editFormValue).length === 0) {
      const payload = {
        ip: values?.ipAddress,
      };
      dispatch(CreateIpWhteList(payload)).then(() => {
        !isLoading && handleClose();
        dispatch(GetIpWhteList());
      });
    }
  };

  // Function to get Local IP
  const getLocalIP = () => {
    return new Promise<string | null>((resolve) => {
      const peerConnection = new RTCPeerConnection({
        iceServers: [{ urls: "stun:stun.l.google.com:19302" }],
      });

      peerConnection.createDataChannel(""); // Create a data channel
      peerConnection
        .createOffer()
        .then((offer) => peerConnection.setLocalDescription(offer))
        .catch(() => resolve(null));

      peerConnection.onicecandidate = (event) => {
        if (event.candidate) {
          const ipMatch = event.candidate.candidate.match(
            /\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/
          );
          if (ipMatch) {
            resolve(ipMatch[0]); // Return the first IP match
            peerConnection.close();
          }
        }
      };

      setTimeout(() => {
        resolve(null); // Timeout after 5 seconds
        peerConnection.close();
      }, 5000);
    });
  };

  // useEffect(() => {
  //     form.resetFields();
  //     form.setFieldsValue(editFormValue); // Set form values when editFormValue changes
  // }, [editFormValue, form]);
  useEffect(() => {
    if (isModalOpen) {
      if (Object.keys(editFormValue).length) {
        form.setFieldsValue(editFormValue);
      } else {
        form.resetFields();
      }
    }
  }, [isModalOpen]);

  useEffect(() => {
    getLocalIP().then((ip) => {
      if (ip) {
        setCurrentIp(ip);
      }
    });
  }, []); // Fetch IP only once when component mounts

  return (
    <Modal
      title={
        <div style={{ fontSize: "20px", position: "relative" }}>
          Add IP Address
          <span
            className="custom-close-button"
            onClick={handleClose}
            style={{
              position: "absolute",
              right: 0,
              top: 0,
              cursor: "pointer",
            }}
          >
            <CloseSvg />
          </span>
        </div>
      }
      open={isModalOpen}
      onCancel={handleClose}
      centered
      width={500}
      closeIcon={false}
      footer={null}
      className="custom-ip-modal"
    >
      <Form
        form={form}
        onFinish={onSubmit}
        name="ipAddressForm"
        autoComplete="off"
        className="form_margin"
      >
        <div className="input-icon__title">
          <label style={{ fontSize: "16px", fontWeight: 500 }}>
            IP Address<span className="required-color"> *</span>
          </label>
        </div>
        <div className="input-icon__form">
          <Form.Item
            name="ipAddress"
            rules={[
              {
                pattern:
                  /^(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)$/,
                message: "Enter a valid IP Address like 192.168.1.1",
              },
              {
                required: true,
                message: "Please enter an IP Address!",
              },
            ]}
          >
            <Input
              placeholder="Enter IP Address"
              size="large"
              className="-icon__form--input"
              type="text"
            />
          </Form.Item>
        </div>
        <div className="integration-model__button">
          <Button
            htmlType="submit"
            className="integration-model__button--save integration-model__button--btn"
            loading={isLoading}
          >
            Add to Whitelist
          </Button>
          {/* <button
              type="button"
              onClick={handleClose}
              className="integration-model__button--cancel integration-model__button--btn"
            >
              Cancel
            </button> */}
        </div>
      </Form>
    </Modal>
  );
};

export default CreateAPIKeyModal;
